import {useMemo} from "react";
import {Area} from "recharts";
import {BaseChart, ChartComponent} from "./BaseChart";
import {TimeSeriesDataProps} from "../../../types/timeSeriesDataProps";
import {FieldResult} from "../../../types/domain/fieldResult";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
export interface NetCarbonSupplyInSoilChartDataProps {
    netCarbonSupplyInSoilCumulative: number;
    deltaOrganicMatterContent: number;
}

export const NetCarbonSupplyInSoilChart: ChartComponent = ({data}) => {
    const {t} = useTranslation();
    const chartData = useMemo(() => data.map(mapFieldResultsToChartData), [data]);

    return (
        <BaseChart
            title={t("insights.charts.net_carbon_supply_in_soil.title")}
            yLabel="mg/kg"
            data={chartData}
            helpPopoverTranslationKey="help.popover.fields.net_carbon_supply"
        >
            <Area
                type="monotone"
                dataKey="netCarbonSupplyInSoilCumulative"
                name={t("insights.charts.net_carbon_supply_in_soil.area1_name")}
                unit="mg/kg"
                yAxisId="left"
                stroke="#00CA4D"
                fill="#A0FFC4"
                strokeWidth={2}
                isAnimationActive={false}
                fillOpacity="1"
                opacity="1"
            />
            <Area
                type="monotone"
                dataKey="deltaOrganicMatterContent"
                name={t("insights.charts.net_carbon_supply_in_soil.area2_name")}
                unit="mg/kg"
                yAxisId="left"
                stroke="#404DB8"
                fill="#CBD3F0"
                strokeWidth={2}
                isAnimationActive={false}
                fillOpacity="1"
                opacity="1"
            />
        </BaseChart>
    );
};

const mapFieldResultsToChartData = (r: FieldResult): DataProps => ({
    date: dayjs(r.date).toDate(),
    netCarbonSupplyInSoilCumulative: r.aggregatedProps.net_carbon_supply_in_soil_cumulative,
    deltaOrganicMatterContent: r.aggregatedProps.delta_organic_matter_content,
});

export interface DataProps extends TimeSeriesDataProps {
    netCarbonSupplyInSoilCumulative: number;
    deltaOrganicMatterContent: number;
}
